
import { ShallowRef, defineComponent, shallowRef } from 'vue';
import Courses from '@/views/Courses/Index.vue';
import Usage from '@/views/Usage/Index.vue';
import PublicCourses from '@/views/PublicCourses/Index.vue';
import PartnerRegions from '@/views/PartnerRegions/Index.vue';
import Settings from '@/views/Settings/Index.vue';

export default defineComponent({
    data() {
        return {
            currentTabIndex: 0,
            tabs: [
                {
                    component: shallowRef(Courses),
                },
                {
                    component: shallowRef(Usage),
                },
                {
                    component: shallowRef(PartnerRegions),
                },
                {
                    component: shallowRef(Settings),
                },
            ] as { component: ShallowRef<any> }[],
            isPublic: false,
        };
    },
    created() {
        if (!window.location.href.includes('wp-admin')) {
            this.isPublic = true;
            this.tabs[0] = { component: shallowRef(PublicCourses) };
        }
    },
    computed: {
        currentTab(): any {
            return this.tabs[this.currentTabIndex];
        },
    },
});
